// extracted by mini-css-extract-plugin
export default {"owner":"ZvmucHROhUeSo0yOQvos"};